import {createAction, ActionCreator} from '@packages/utilities/create-action';
import {
  PseudoStateKey,
  CustomNodeStateKey,
} from '@packages/systems/core/utils/StyleTypes';
import {
  APPLICATION_LOADED,
  IMPORTED_TIMEZONE,
  PSEUDO_MODE_SELECTED,
  SELECTED_RULES_CHANGED,
  SETTINGS_SECTION_TOGGLED,
  WINDOW_DIMENSIONS_UPDATED,
  __DEPRECATED__RULE_SELECTED,
} from '@packages/systems/designer/actions';

export const selectPseudoMode: ActionCreator<
  typeof PSEUDO_MODE_SELECTED,
  null | PseudoStateKey | CustomNodeStateKey
> = createAction(PSEUDO_MODE_SELECTED);

export const applicationLoaded: ActionCreator<typeof APPLICATION_LOADED, void> =
  createAction(APPLICATION_LOADED);

export const ruleSelected: ActionCreator<
  typeof __DEPRECATED__RULE_SELECTED,
  {rule: unknown}
> = createAction(__DEPRECATED__RULE_SELECTED);

export const selectedRulesChanged: ActionCreator<
  typeof SELECTED_RULES_CHANGED,
  void
> = createAction(SELECTED_RULES_CHANGED);

export const toggleSettingsSection: ActionCreator<
  typeof SETTINGS_SECTION_TOGGLED,
  {section: string}
> = createAction(SETTINGS_SECTION_TOGGLED);

export const importTimezone: ActionCreator<typeof IMPORTED_TIMEZONE, string> =
  createAction(IMPORTED_TIMEZONE);

export const updateWindowDimensions: ActionCreator<
  typeof WINDOW_DIMENSIONS_UPDATED,
  {
    windowDimensions: {
      width: number;
      height: number;
    };
  }
> = createAction(WINDOW_DIMENSIONS_UPDATED);
